// ─── PCP deep links — ONE route table for every entity that has a detail page ──
//
// Shared by the API (the MCP server hands every entity back with its `pcpUrl`,
// notifications land on their entity) and the web app. Pure and dependency-free
// so it runs in Node and the browser alike.
//
// The ORIGIN is deliberately not known here. On the API it is
// MCP_PUBLIC_URL || RP_ORIGIN — https://pcp.realequity.ai on prod,
// https://pcp.int.realequity.ai on int — and in the browser it is
// window.location.origin. Callers pass it in; this file only knows the paths.
//
// Routes have moved in this codebase before (/discourse/:id → /topics/:id,
// /azure-devops/:id → /backlog/:id, each surviving only as a redirect), which is
// why the path lives in exactly one place rather than in every string template
// that wants to link somewhere. (f-01975)
/** App-relative detail-page prefix per entity kind; the id is appended. */
export const PCP_ENTITY_ROUTES = {
    /** An Azure DevOps work item — Feature / User Story / Bug — by its ADO id. */
    backlog: '/backlog/',
    /** A Zoho Desk ticket by its Zoho id. */
    ticket: '/tickets/',
    /** A Discourse topic by its topic id. */
    topic: '/topics/',
    /** A Feedback Board by uuid. */
    feedback: '/feedback/',
    /** A feature/bug request — by its REF ID (f-00123 / b-00045), which the route resolves. */
    request: '/requests/',
    /** A release-notes entry by uuid. */
    release: '/release-notes/',
    /** A knowledge article by SLUG (the reader route). */
    knowledge: '/knowledge/articles/',
    /** A Smartguide (content item) by uuid. */
    guide: '/guides/',
    /** A Smartguides host app by uuid. */
    guideApp: '/guides/apps/',
    /** A status-page incident by uuid. */
    incident: '/status/incidents/',
};
export const PCP_ENTITY_KINDS = Object.keys(PCP_ENTITY_ROUTES);
/** The app-relative deep link of one entity, e.g. `/backlog/21234`. */
export function pcpEntityPath(kind, id) {
    return `${PCP_ENTITY_ROUTES[kind]}${encodeURIComponent(String(id))}`;
}
/**
 * The ABSOLUTE deep link of one entity, or null when there is nothing sound to
 * build it from: no origin configured, or no id. A relative link is not
 * returned in that case on purpose — an agent pastes what it is given, and
 * `/backlog/21234` in a chat message is a dead link, not a nearly-right one.
 */
export function pcpEntityUrl(origin, kind, id) {
    const base = String(origin ?? '').trim().replace(/\/+$/, '');
    if (!base)
        return null;
    if (id == null || id === '')
        return null;
    return `${base}${pcpEntityPath(kind, id)}`;
}
//# sourceMappingURL=pcp-links.js.map